// Design Conductor returns preview URLs either protocol-relative (`//...`) or already
// absolute (`https://...`). Only the protocol-relative form needs a scheme prepended.
export const normalizePreviewUrl = (previewUrl: string): string => (
    previewUrl.startsWith('//') ? `https:${previewUrl}` : previewUrl
);

// Design Conductor renders previews onto a scene by default. Removing the `scene` query
// param yields the flat, scene-less render, which DC will not produce on its own.
export const stripSceneFromPreviewUrl = (previewUrl: string): string => {
    const normalized = normalizePreviewUrl(previewUrl);

    try {
        const url = new URL(normalized);

        url.searchParams.delete('scene');
        return url.toString();
    } catch {
        return normalized;
    }
};
